import { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import ArticleListCard from './components/ArticleListCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const currentCategory = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const handleCategoryChange = (newSlug: string) => {
    navigate(`/category/${newSlug}`);
  };

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700">{currentCategory?.name || '分类'}</span>
            </nav>

            <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              {currentCategory?.name || '分类'}
            </h1>
            <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-2xl">
              {currentCategory?.description || ''}
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-8">
              <aside className="w-full lg:w-56 flex-shrink-0">
                <h4 className="text-sm font-semibold text-foreground-800 mb-4">知识分类</h4>
                <nav className="flex lg:flex-col gap-2 flex-wrap">
                  {categories.map((cat) => (
                    <button
                      key={cat.slug}
                      onClick={() => handleCategoryChange(cat.slug)}
                      className={`flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition-all duration-200 text-left whitespace-nowrap cursor-pointer ${
                        slug === cat.slug
                          ? 'bg-accent-100 text-accent-700 font-medium'
                          : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-800'
                      }`}
                    >
                      <div className={`w-6 h-6 flex items-center justify-center ${slug === cat.slug ? 'text-accent-600' : 'text-foreground-400'}`}>
                        <i className={`${cat.icon} text-base`}></i>
                      </div>
                      {cat.name}
                    </button>
                  ))}
                </nav>
              </aside>

              <div className="flex-1 min-w-0">
                {articles.length > 0 ? (
                  <div className="space-y-5">
                    {articles.map((article) => (
                      <ArticleListCard key={article.slug} article={article} />
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-20">
                    <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100">
                      <i className="ri-file-list-3-line text-2xl text-foreground-300"></i>
                    </div>
                    <p className="mt-4 text-foreground-500">该分类下暂无文章</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}